<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">

    <!-- Cabeçalho da página -->
    <div class="page-head">
      <div class="page-head-text">
        <h1 class="title-default">Configuração do Kanban de Oportunidades</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Defina as etapas do fluxo, seus campos e movimentos permitidos.
        </p>
      </div>
    </div>

    <!-- Resumo da configuração -->
    <section class="fluxo-section">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">summarize</mat-icon>
        <span>Resumo configuração</span>
      </div>
      <div class="resumo-stats">
        <span class="resumo-item">
          <mat-icon class="material-symbols-outlined">splitscreen</mat-icon>
          <strong>{{ totalEtapasFluxo }}</strong> etapas do fluxo
        </span>
        <span class="resumo-item">
          <mat-icon class="material-symbols-outlined">flag</mat-icon>
          <strong>{{ totalEtapasFinais }}</strong> {{ labelEtapasFinais }}
        </span>
        <span class="resumo-item">
          <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
          <strong>{{ totalCamposConfigurados }}</strong> campos configurados
        </span>
      </div>
    </section>

    <!-- Fluxo principal -->
    <section class="fluxo-section">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">route</mat-icon>
        <span>Fluxo principal</span>
        <div class="section-title-actions ms-auto">
          <button mat-flat-button class="btn-primary" type="button" (click)="novaEtapa()">
            <mat-icon class="material-symbols-outlined">add</mat-icon> Nova etapa
          </button>
        </div>
      </div>
      <p class="fluxo-section-sub">
        Etapas pelas quais os cards passam em ordem. As etapas padrão têm posição fixa —
        apenas etapas criadas por você podem ser reordenadas.
      </p>

      @if (_isLoading && etapas.length === 0) {
      <app-loading-box-default-list></app-loading-box-default-list>
      } @else if (etapasPrincipais.length > 0) {

      <div class="etapas-list" cdkDropList (cdkDropListDropped)="drop($event)">
        @for (etapa of etapasPrincipais; track etapa.idEtapaKanban) {
        <div class="etapa-card" cdkDrag [cdkDragDisabled]="etapa.isFixo"
          [style.border-left-color]="etapa.cor">
          <div class="etapa-card-placeholder" *cdkDragPlaceholder></div>
          <ng-container
            *ngTemplateOutlet="rowContent; context: { etapa: etapa, arrastavel: true }"></ng-container>
        </div>
        }
      </div>

      } @else {
      <app-empty-list [title]="'Nenhuma etapa configurada'"
        [subTitle]="'Adicione uma nova etapa para montar o fluxo'"></app-empty-list>
      }
    </section>

    <!-- Etapas finais -->
    @if (etapasFinais.length > 0) {
    <section class="fluxo-section">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">flag</mat-icon>
        <span>Etapas finais</span>
      </div>
      <p class="fluxo-section-sub">
        Encerram o fluxo: recebem cards de qualquer etapa permitida e não têm saída. Ficam sempre
        no fim do quadro e não entram na reordenação.
      </p>

      <div class="etapas-list">
        @for (etapa of etapasFinais; track etapa.idEtapaKanban) {
        <div class="etapa-card" [style.border-left-color]="etapa.cor">
          <ng-container
            *ngTemplateOutlet="rowContent; context: { etapa: etapa, arrastavel: false }"></ng-container>
        </div>
        }
      </div>
    </section>
    }

  </div>
</div>

<!-- Linha de etapa, reaproveitada pelo fluxo principal e pelas etapas finais -->
<ng-template #rowContent let-etapa="etapa" let-arrastavel="arrastavel">
          @if (arrastavel) {
          <span class="etapa-handle" [class.etapa-handle--fixo]="etapa.isFixo" cdkDragHandle
            [matTooltip]="etapa.isFixo ? 'Etapa padrão (posição fixa)' : 'Arraste para reordenar'">
            <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
          </span>
          } @else {
          <span class="etapa-handle etapa-handle--fixo" matTooltip="Etapa final — posição fixa no fim do fluxo">
            <mat-icon class="material-symbols-outlined">lock</mat-icon>
          </span>
          }

          <span class="etapa-numero">{{ etapa.ordem }}</span>

          <span class="etapa-icone" [style.background-color]="etapa.tint" [style.color]="etapa.cor">
            <mat-icon class="material-symbols-outlined">{{ etapa.icone }}</mat-icon>
          </span>

          <div class="etapa-info">
            <div class="etapa-nome-linha">
              <span class="etapa-nome text-bold">{{ etapa.nome }}</span>
              @if (etapa.isFinal) {
              <span class="status-badge badge-cinza etapa-badge">Final</span>
              }
            </div>
            <p class="etapa-descricao text-secondary">{{ etapa.descricao }}</p>
          </div>

          <div class="etapa-stats">
            <div class="etapa-stat">
              <span class="etapa-stat-num">
                <mat-icon class="material-symbols-outlined">list_alt</mat-icon>{{ etapa.qtdCampos }}
              </span>
              <span class="etapa-stat-label">Campos</span>
            </div>
            <div class="etapa-stat">
              <span class="etapa-stat-num">
                <mat-icon class="material-symbols-outlined">trending_flat</mat-icon>{{ etapa.qtdDestinos }}
              </span>
              <span class="etapa-stat-label">Destinos</span>
            </div>
          </div>

          <div class="etapa-status">
            @if (!etapa.isFixo) {
            <mat-slide-toggle class="app-toggle-compact" color="primary" [checked]="etapa.isAtivo"
              [attr.aria-label]="etapa.isAtivo ? 'Etapa ativa' : 'Etapa inativa'"
              (change)="toggleAtivo(etapa, $event.checked)">
            </mat-slide-toggle>
            <span class="etapa-status-label">{{ etapa.isAtivo ? 'Ativo' : 'Inativo' }}</span>
            } @else {
            <span class="etapa-fixo" matTooltip="Etapa fixa do fluxo: não pode ser inativada">
              <mat-icon class="material-symbols-outlined">lock</mat-icon> Fixo
            </span>
            }
          </div>

          <div class="etapa-acoes">
            <button mat-icon-button type="button" [matMenuTriggerFor]="menuEtapa" matTooltip="Mais ações">
              <mat-icon class="material-symbols-outlined">more_horiz</mat-icon>
            </button>
            <mat-menu #menuEtapa="matMenu">
              <button mat-menu-item (click)="editarEtapa(etapa)">
                <mat-icon class="material-symbols-outlined">edit</mat-icon><span>Editar etapa</span>
              </button>
              <!-- O tooltip fica no wrapper porque um mat-menu-item desabilitado não emite eventos de mouse. -->
              <span [matTooltip]="tooltipEtapaPadrao" [matTooltipDisabled]="!etapa.isFixo">
                <button mat-menu-item (click)="excluirEtapa(etapa)" [disabled]="etapa.isFixo">
                  <mat-icon class="material-symbols-outlined" [class.text-danger]="!etapa.isFixo">
                    {{ etapa.isFixo ? 'lock' : 'delete' }}
                  </mat-icon><span>Excluir etapa</span>
                </button>
              </span>
            </mat-menu>
          </div>
</ng-template>
